<dashboard-dialog-frame [header]="'Add Venture'" [dialogRef]='dialogRef'>

	<div class="p-3 h-100 d-flex flex-column justify-content-between">
		<div>
			<common-select-field [field]="ventureId()"></common-select-field>
		</div>

		@if(availabilityCheck(); as availability){
		@if(availability.existingAccTeamName; as existingAccTeamName){
		<div class="text-danger">
			<p>This venture record already is associated with an Accelerator Team: {{existingAccTeamName}}, for this trimester.</p>
			<p>Do you still want to add them to this team?</p>
		</div>
		} @else {
		<div class="text-success">
			<p>This venture record is available to be added to this Accelerator Team.</p>
		</div>
		}
		}

		<div class="mt-3">
			<common-button-row [center]="true">
				<!-- Keep save button in DOM (required for form submission) but hide it when validation fails -->
				<button class="btn btn-standard" #saveBtn>{{buttonText()}}</button>
				<button class="btn btn-standard" (click)="dialogRef.close()">Close</button>
			</common-button-row>
		</div>
	</div>

</dashboard-dialog-frame>